import React from "react"

import type { PublicListingFieldsFragment } from "~graphql/generated/graphql"
import ListingHeader from "~components/pages/listing/listing-header"
import ListingDetails from "~components/pages/listing/listing-details"

interface Props {
    readonly listing: PublicListingFieldsFragment
}

export function ListingContent({ listing }: Props) {
    return (
        <>
            <ListingHeader listing={listing} />
            <ListingDetails />
        </>
    )
}
